// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const guestList_noGuestsYet = (i) => `Bisher hat noch kein Gast geantwortet. <br>Aber das wird bestimmt noch.`